import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/**
 * The `listValueChains` tool call: the value chain maps of the user's company.
 *
 * Takes no input, so there is nothing under the header. Once the list is in, the status says how
 * long it is; the maps themselves are not shown yet.
 */
function ListValueChainsToolCall({ part }: IAiChatToolCallOf<'listValueChains'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('listValueChains');
  const status = useAiChatToolStatus(part.state);

  const summary = part.state === 'output-available'
    ? t('aiChat.tools.valueChainsListed', { count: part.output.length })
    : status;

  return <AiChatToolCard name={label} status={summary} errorText={part.errorText} />;
}

export default ListValueChainsToolCall;
